import { TanStackDevtools } from '@tanstack/react-devtools'
import {
  Outlet,
  createRootRouteWithContext,
  useMatches,
} from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'

import type { QueryClient } from '@tanstack/react-query'
import TanStackQueryDevtools from '@/integrations/tanstack-query/devtools'

import { Footer } from '@/components/layout/Footer'
import { Header } from '@/components/layout/Header'
import { CookieConsent } from '@/components/cookie-consent'
import { CookieConsentProvider } from '@/contexts/CookieConsentContext'

interface MyRouterContext {
  queryClient: QueryClient
}

const RootComponent = () => {
  const matches = useMatches()
  const lastMatch = matches[matches.length - 1]
  const isLight =
    (lastMatch.staticData as { headerLight?: boolean }).headerLight ?? false
  const shouldShowDevtools = import.meta.env.DEV

  return (
    <CookieConsentProvider>
      <Header isLight={isLight} />
      <main className="pt-[90px]">
        <Outlet />
      </main>
      {shouldShowDevtools && (
        <TanStackDevtools
          config={{
            position: 'bottom-right',
          }}
          plugins={[
            {
              name: 'Tanstack Router',
              render: <TanStackRouterDevtoolsPanel />,
            },
            TanStackQueryDevtools,
          ]}
        />
      )}
      <Footer />
      <CookieConsent />
    </CookieConsentProvider>
  )
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootComponent,
})
